import { render } from "./compania.vue?vue&type=template&id=170e9203"
import script from "./compania.vue?vue&type=script&lang=js"
export * from "./compania.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__